import { createApp } from "vue"
import App from "./App.vue"
import { router } from "./router.js"
import { installDeployRecovery, installNewVersionReload } from "./lib/deploy.js"
import "./style.css"

installDeployRecovery(router)
installNewVersionReload(router)   // a deploy while the tab is open: reload on the next navigation
createApp(App).use(router).mount("#app")

// Register the PWA service worker (installable on Android/iOS, light offline).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {})
  })
}
